import { APIQuotationContext, Offer } from 'src/app/shared/models/price-object';

export class QuotationData {
    insurerName: string;
    insurerUrl: string;
    quotationContext: APIQuotationContext;
    offer: Offer;
    priceUserInput: object;
}
